import { render, staticRenderFns } from "./add-bak.vue?vue&type=template&id=7e8d8fd8&"
import script from "./add-bak.vue?vue&type=script&lang=js&"
export * from "./add-bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports